import React, { useState } from 'react';
import { DEFAULT_PACKAGE_IMAGE } from '../../constants/appConstant';
import './Image.css';
import { getMMT_HLD_OBJ } from '../../utils/appUtils';

const Image = props => {
  const [isLoading, setIsLoading] = useState(true);

  const {
    src,
    name,
    width,
    height,
    imgClass,
    alt,
    defaultImg,
    borderRadius,
    imageClickHandler,
    classes = '',
  } = props;
  let defaultImage = DEFAULT_PACKAGE_IMAGE;
  if (defaultImg) {
    defaultImage = defaultImg;
  }
  const finalImg = src || defaultImage;
  const containerStyle = {};
  if (isLoading) {
    containerStyle.backgroundImage = `url(${defaultImage})`;
  }
  if (isLoading) {
    containerStyle.backgroundImage = `url(${defaultImage})`;
  }
  if (width) {
    containerStyle.width = `${width}px`;
  }
  if (height) {
    containerStyle.height = `${height}px`;
  }

  let borderRadiusStyle = {};
  if (borderRadius) {
    borderRadiusStyle = {
      borderRadius: `${borderRadius}px`,
    };
  }
  const renderSSRImage = () => (
    <img
      className={`${imgClass || ''} ${!isLoading ? 'active' : ''}`}
      width={width}
      height={height}
      src={`${finalImg}?downsize=${width}:${height}`}
      alt={alt || name}
      title={name}
      onClick={imageClickHandler || (() => {})}
    />
  );

  const renderImage = () => (
    <div
      className={`${
        !getMMT_HLD_OBJ().fromSEO ? 'imageLoaderContainer' : 'imageLoaderContainerSSR'
      } ${classes}`}
      style={containerStyle}
    >
      <img
        className={`${imgClass || ''} ${!isLoading ? 'active' : ''} ${
          imageClickHandler ? 'pointer' : ''
        }`}
        width={width}
        height={height}
        style={borderRadiusStyle}
        src={`${finalImg}?downsize=${width}:${height}`}
        alt={alt || name}
        title={name}
        onLoad={() => setIsLoading(false)}
        onClick={imageClickHandler || (() => {})}
      />
    </div>
  );

  return ssr.isOnClient ? renderImage() : renderSSRImage();
};

export default Image;
